// extracted by mini-css-extract-plugin
export default {"wrap":"UE-z","fullWidth":"VE-z","hideOnDesktop":"WE-z","content":"XE-z","hasOpenedNav":"YE-z","crumbsList":"ZE-z","dropdownsWrap":"_E-z"};